import { render } from "./Colour.vue?vue&type=template&id=5ea0d8f4"
import script from "./Colour.vue?vue&type=script&lang=js"
export * from "./Colour.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__